// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { useLocation, Link } from 'react-router-dom'
import { IonSkeletonText, IonText } from '@ionic/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconDefinition } from '@fortawesome/fontawesome-common-types'
import useSession from './useSession'


interface SectionMenuItemProps {
  icon: IconDefinition
  title: string
  path: string
}

const SectionMenuItem: React.FC<SectionMenuItemProps> = ({
  icon,
  path,
  title
}) => {
  const location = useLocation()
  const {ready} = useSession()
  const classes: string[] = ["menu-item"]
  if (location.pathname.startsWith(path)) {
    classes.push("active")
  }
  if (!ready) {
    classes.push("loading")
  }
  return (
    <div className={classes.join(" ")}>
      <Link to={path}>
        <span className="icon">
          <FontAwesomeIcon icon={icon}/>
        </span>
        <span className="title">
          {(!!ready) ? (<IonText>{title}</IonText>) : (<IonSkeletonText animated={true} style={{width: '100%' }}/>)}
        </span>
      </Link>
    </div>
  )
}

export default SectionMenuItem